import React from 'react';
import styles from '../BusinessDashboard/index.module.css';
import checkedImg from '../../assets/icons/checked.svg';
import uncheckedImg from '../../assets/icons/notchecked.svg';

const SettingSteps = ({ step }: any) => {
  const benefits = [
    {
      name: 'profile-information',
      title: 'Profile Information',
      no: 1,
    },
    {
      name: 'security',
      title: 'Security',
      no: 2,
    },
    {
      name: 'business-information',
      title: 'Business Information',
      no: 3,
    },
    // {
    //   name: 'payment-services',
    //   title: 'Payment Services',
    //   no: 4,
    // },
  ];

  return (
    <div
      className={[styles.benefitsContainer, 'mt-7 lg:mt-0 lg:min-w-[200px] lg:h-[100%]'].join(' ')}
    >
      <div className='text-black  text-xs font-Poppins '>
        <div className='text-sm pt-[44px] px-4'>
          {'You can always click on any button to go back and edit any section you miss'}
        </div>

        {benefits.map((benefit: any, index: number) => (
          <div
            className='mt-3 p-[15px] text-white text-xs font-Poppins flex bg-green justify-between flex-row gap-1 items-start'
            key={index}
          >
            <div className='flex space-x-2'>
              <h6 className='text-white text-xs font-Poppins'>{index + 1}. </h6>
              <div className='font-poppins capitalize  text-[12px]'> {benefit.title}</div>
            </div>

            <img
              src={step.toString() > benefit.no.toString() ? checkedImg : uncheckedImg}
              alt={step.toString() > benefit.no.toString() ? 'checked' : 'unchecked'}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default SettingSteps;
